import { render, staticRenderFns } from "./xnfzItem.vue?vue&type=template&id=090d93e6&scoped=true"
import script from "./xnfzItem.vue?vue&type=script&lang=js"
export * from "./xnfzItem.vue?vue&type=script&lang=js"
import style0 from "./xnfzItem.vue?vue&type=style&index=0&id=090d93e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090d93e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('090d93e6')) {
      api.createRecord('090d93e6', component.options)
    } else {
      api.reload('090d93e6', component.options)
    }
    module.hot.accept("./xnfzItem.vue?vue&type=template&id=090d93e6&scoped=true", function () {
      api.rerender('090d93e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/xnfzItem.vue"
export default component.exports